<template>
  <v-row no-gutters align="center">
    <v-col class="pr-5">
      <v-text-field
        v-model="inputedValue.lastName"
        :placeholder="$t('common.input_last-name')"
        outlined
        dense
        hide-details
        :height="height"
      >
      </v-text-field>
    </v-col>
    <v-col>
      <v-text-field
        v-model="inputedValue.firstName"
        :placeholder="$t('common.input_first-name')"
        outlined
        dense
        hide-details
        :height="height"
      >
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      require: true,
      default: () => ({})
    },
    height: { default: '32px' }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
